import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* reportDownload(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_REPORT_DOWNLOAD_REQUEST
    });

    const res = yield call(Http.post, `reports/${action.payload?.reportTypeId}`, {
      ...action.payload
    });

    yield put({
      type: Constants.GLOBAL_REPORT_DOWNLOAD_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_REPORT_DOWNLOAD_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchReportDownload() {
  yield takeEvery(Constants.GLOBAL_REPORT_DOWNLOAD_START, reportDownload);
}
